import { Component } from '@angular/core';
import { PostService } from 'src/app/services/repositories/post.service';

@Component({
  selector: 'app-publication-tracker',
  templateUrl: './publication-tracker.component.html',
  styleUrls: ['./publication-tracker.component.scss']
})
export class PublicationTrackerComponent {
  globalPlannedJobs:string = "--";
  globalFailedJobs:string = "--";
  globalDrafts:string = "--";
  globalPlanned:string = "--";
  globalPublished:string = "--";
  globalFailed:string = "--";
  groupsWithSocialMedias:string = "--";
  groupsWthoutSocialMedias:string = "--";
  instaPages:string = "--";
  facebookPages:string = "--";
  linkedinPages:string = "--";
  googlePages:string = "--";
  postsPublished:string="--"
  postsNeverPublished:string="--"

  filters:any = {
   postTitle:null,
   status:"creating",
   groupName:null,
   source:null,
  }
  dataTable:any[]=[]

  constructor(private postService:PostService) { }
  ngOnInit(){
    this.fetchGlobalStats()
    this.fetchPosts()
  }

  fetchGlobalStats(){
    this.postService.getGlobalStats().subscribe((data:any)=>{

      this.globalPlannedJobs = data.plannedJobs;
      this.globalFailedJobs = data.failedJobs;
      this.globalDrafts = data.drafts;
      this.globalPlanned = data.planned;
      this.globalPublished = data.published;
      this.globalFailed = data.failed;
      this.groupsWithSocialMedias = data.groupsWithSocialMedias;
      this.groupsWthoutSocialMedias = data.groupsWthoutSocialMedias;
      this.instaPages = data.instaPages;
      this.facebookPages = data.facebookPages;
      this.linkedinPages = data.linkedinPages;
      this.googlePages = data.googlePages;
      this.postsPublished=data.postsPublished;
      this.postsNeverPublished=data.postsNeverPublished
    })
  }

  fetchPosts(){
    this.postService.publicationTracker(this.filters).subscribe((data:any)=>{
      console.log("filters respons")
    })
  }
}
